var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounTick317767222222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1051.2,369.6L512.4,930c-30,31.2-78,31.2-108,0L135.6,648c-30-31.2-30-81.6,0-112.8s78-31.2,108,0l216,225.6 l484.8-504c30-31.2,78-31.2,108,0C1081.2,288,1081.2,338.4,1051.2,369.6L1051.2,369.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounTick317767222222);
export default __webpack_public_path__ + "static/media/noun-tick-317767-222222.75025117df77178fa41b8084b0a3aded.svg";
export { ForwardRef as ReactComponent };